const home = {
  hero: {
    badge: "Family-Owned Business · Royal Palm Beach, FL",
    title1: "Adry & Mich",
    title2: "Cleaning & Handyman",
    title3: "Cleaning · Repairs · Reliable Service You Can Trust",
    subtitle: "Professional home cleaning, dog sitting & handyman services in Royal Palm Beach, FL & surrounding areas. We treat your home like our own — spotless results, every time.",
    cta1: "Get a Free Quote",
    cta2: "Explore Services",
    badge2: "★★★★★ 100% Satisfaction Guaranteed",
  },
  services: {
    title: "Our Services",
    subtitle: "Complete solutions for your home — cleaning and repairs under one roof.",
    cleaning: {
      title: "Cleaning Services",
      desc: "Professional cleaning tailored to your home's needs.",
      items: ["Residential Cleaning", "Deep Cleaning", "Move-in / Move-out", "Airbnb Cleaning"],
      cta: "View All Cleaning Services →",
    },
    handyman: {
      title: "Handyman Services",
      desc: "Reliable repairs and installations for every corner of your home.",
      items: ["Drywall Repair", "Door Repairs", "Interior Painting", "TV Mounting"],
      cta: "View All Handyman Services →",
    },
  },
  why: {
    title: "Why Choose Us",
    subtitle: "We're not just a service — we're your trusted home care partners.",
    items: [
      { icon: "ri-home-heart-line", title: "Family-Owned", desc: "Personal care and trust in every job we do." },
      { icon: "ri-focus-3-line", title: "Attention to Detail", desc: "We don't cut corners — every spot gets the attention it deserves." },
      { icon: "ri-shield-check-line", title: "Reliable & Honest", desc: "We show up on time and deliver what we promise." },
      { icon: "ri-tools-line", title: "All-in-One Solution", desc: "Cleaning + repairs — no need to hire multiple companies." },
    ],
  },
  who: {
    title: "Who We Help",
    subtitle: "We serve a wide range of clients across Royal Palm Beach and surrounding areas.",
    items: [
      { icon: "ri-group-line", label: "Busy Families" },
      { icon: "ri-building-line", label: "Airbnb Hosts" },
      { icon: "ri-home-2-line", label: "Property Owners" },
      { icon: "ri-heart-line", label: "Elderly Needing Help" },
      { icon: "ri-star-line", label: "Anyone Who Wants a Clean Home" },
    ],
  },
  testimonials: {
    title: "What Our Clients Say",
    subtitle: "Real reviews from real customers who trust us with their homes.",
    viewAll: "View All Testimonials",
  },
  ctaBanner: {
    title: "Ready for a Spotless Home?",
    subtitle: "Contact us today and get your free quote. We respond fast!",
    cta1: "Call: (561) 262-6118",
    cta2: "Send WhatsApp",
  },
};

export default home;
